"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const UI_1 = require("~/components/UI");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const utils_1 = require("~/utils/utils");
const BOMItemPrice_1 = __importDefault(require("../BOMItemPrice"));
const PriceTooltip_1 = __importDefault(require("../PriceTooltip"));
const BOMAssemblyChargeItem_scss_1 = __importDefault(require("./BOMAssemblyChargeItem.scss"));
const BOMLineItemUtils_1 = require("../BOMLineItemUtils");
function BOMAssemblyChargeItem({ assemblyChargeItems, parentLineItemNumber }) {
    const [isDescriptionOverflowing, setDescriptionOverflowing] = (0, react_1.useState)(false);
    const isBOMEditMode = (0, react_redux_1.useSelector)(selectors_1.selectBOMEditMode);
    const { dispatchToggleAssemblyChargeForItem } = (0, redux_1.bindActionCreators)({
        dispatchToggleAssemblyChargeForItem: actions_1.toggleAssemblyChargeForItem,
    }, (0, react_redux_1.useDispatch)());
    const includedAssemblyChargeItems = assemblyChargeItems.filter((item) => item.isAssemblyChargeIncluded);
    const displayedAssemblyChargeItems = isBOMEditMode ? assemblyChargeItems : includedAssemblyChargeItems;
    return (react_1.default.createElement(react_1.default.Fragment, null, displayedAssemblyChargeItems.map((item, index) => {
        var _a;
        const includedItemIndex = includedAssemblyChargeItems.findIndex((includedItem) => includedItem.id === item.id);
        const lineItemNumber = includedItemIndex === -1 ? undefined : (0, BOMLineItemUtils_1.getChildLineItemNumber)(parentLineItemNumber, includedItemIndex);
        return (
        // eslint-disable-next-line react/no-array-index-key
        react_1.default.createElement("div", { key: `${item.item_number}-${index}`, className: BOMAssemblyChargeItem_scss_1.default.item },
            react_1.default.createElement("div", { className: BOMAssemblyChargeItem_scss_1.default.arrow }),
            react_1.default.createElement("div", { className: BOMAssemblyChargeItem_scss_1.default.itemLineItem }, lineItemNumber),
            react_1.default.createElement("div", { className: BOMAssemblyChargeItem_scss_1.default.itemImg }, isBOMEditMode && (react_1.default.createElement("div", { className: BOMAssemblyChargeItem_scss_1.default.includeItem },
                react_1.default.createElement(UI_1.Checkbox, { label: "", checked: item.isAssemblyChargeIncluded, onCheck: (value) => {
                        dispatchToggleAssemblyChargeForItem({ id: item.id, isAssemblyChargeIncluded: value });
                    } })))),
            react_1.default.createElement("div", { className: BOMAssemblyChargeItem_scss_1.default.itemNumber }, `#${item.item_number}`),
            react_1.default.createElement("div", { className: BOMAssemblyChargeItem_scss_1.default.itemDescription, onMouseOver: (e) => setDescriptionOverflowing((0, utils_1.isEventTargetOverflowing)(e)), onFocus: (e) => setDescriptionOverflowing((0, utils_1.isEventTargetOverflowing)(e)) },
                react_1.default.createElement(UI_1.Tooltip, { placement: "right-end", contentNode: react_1.default.createElement("div", { className: BOMAssemblyChargeItem_scss_1.default.tooltip }, item.description), disabled: !isDescriptionOverflowing }, item.description)),
            react_1.default.createElement("div", { className: BOMAssemblyChargeItem_scss_1.default.itemQuantity }, (_a = item.assemblyTime) === null || _a === void 0 ? void 0 : _a.toFixed(2)),
            react_1.default.createElement(PriceTooltip_1.default, { price: item.price, unitOfMeasurement: item.unitOfMeasurement || '' }),
            react_1.default.createElement(BOMItemPrice_1.default, { price: item.sum || 0, discountedPrice: item.discountedSum })));
    })));
}
exports.default = BOMAssemblyChargeItem;
